module.exports = __webpack_public_path__ + "static/media/dtus2.4aefb969.jpeg";